import { Collapse, List, Typography } from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import SubItemCloseIcon from "assets/icons/SubItemCloseIcon";
import SubItemOpenIcon from "assets/icons/SubItemOpenIcon";
import { StyledListItemButton, StyledListItemIcon, StyledListItemText } from "components/Reports/components";
import { useState } from "react";

interface ListSubItemProps {
  data: any;
  onChange: (item: any) => void;
  sizes?: {
    font?: number;
  };
}

export default function ListSubItem({ data, onChange, sizes }: ListSubItemProps) {
  const [open, setOpen] = useState(!data.parentId);
  const hasChild = data.childs && data.childs.length > 0;

  function handleClick() {
    if (hasChild) setOpen((open) => !open);
    else onChange(data);
  }

  return (
    <>
      <StyledListItemButton disableRipple active={open} onClick={handleClick} className="flex gap-2">
        {/* <StyledListItemIcon>{open ? <SubItemCloseIcon /> : <SubItemOpenIcon />}</StyledListItemIcon> */}
        {hasChild && <ChevronIcon rotate={open ? undefined : "left"} color="#7E8C9E" />}
        <StyledListItemText>
          <Typography variant="body2" fontSize={sizes?.font || 14}>
            {data?.code && `${data.code} - `}{data.title}
          </Typography>
        </StyledListItemText>
      </StyledListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {data.childs &&
            data.childs.map((item: any, index: any) => {
              return (
                <div key={index} style={{ paddingRight: "16px" }}>
                  <ListSubItem data={item} onChange={onChange} sizes={sizes} />
                </div>
              );
            })}
        </List>
      </Collapse>
    </>
  );
}
